import { env } from "@/app/utils/env";

export const API_ROUTES = {
  WORKSPACE: `${env.BACKEND_URL}/general/workspace/`,
};
